import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'sx-jobSchedule-configuration',
    templateUrl: './jobScheduleConfiguration.component.html',
})

export class JobScheduleConfigurationComponent implements OnInit {

    constructor(
    ) { }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/Schedule/Configuration/jobScheduleConfiguration.component.ts